export enum InvoiceStatusEnum {
    ACTIVE = 'ACTIVE',
    BILLED = 'BILLED',
    PAID = 'PAID',
    REFERENCE = 'REFERENCE',
    CANCELLED = 'CANCELLED'
}
